import { provideChameleonDesignSystem } from '../common/ChameleonDesignSystem';
import { autocompleteDefinition } from './Autocomplete.definition';
export { AutocompleteComponent } from './Autocomplete';
provideChameleonDesignSystem().register(autocompleteDefinition());
